import axios from "utils/axios";

export const getRefBanksSuggestion = (params) => {
  return axios.get('/refBanks/suggestionPerPage', { params });
};